export const STICKY_OFFSET = 250
export const BIG_O_LOGO_IMAGE_SRC = '//tbc.scene7.com/is/image/TBCCorporation/bot-Big-o-logo?wid=40&qlt=50'
